module.exports = __webpack_public_path__ + "static/media/local-18-mobile@3x.bf0bbbb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18-mobile@3x.png
// module id = 1188
// module chunks = 2